export const MCP_ATTRIBUTES = [
  {
    attribute: 'mcp.booster',
    label: 'Booster',
    kind: 'number',
    fallbackType: 'int',
  },
  {
    attribute: 'mcp.calls_per_seat',
    label: 'Calls Per Seat',
    kind: 'number',
    fallbackType: 'int',
  },
  {
    attribute: 'mcp.api_booster',
    label: 'API Booster',
    kind: 'number',
    fallbackType: 'int',
  },
  {
    attribute: 'mcp.hard_cap_enabled',
    label: 'Hard Cap Enabled',
    kind: 'boolean',
    fallbackType: 'bool',
  },
] as const;

export type McpAttributeName = (typeof MCP_ATTRIBUTES)[number]['attribute'];
